// removed by extract-text-webpack-plugin
module.exports = {"main_menu":"Navigation__main_menu__21Hl2","menu_item":"Navigation__menu_item__2w4gF"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/Navigation.scss
// module id = 121
// module chunks = 0